import { useMemo } from 'react';

import { toPools } from '@/helpers/jackpot';

import { useCurrentJackpotCampaign } from './useCurrentJackpotCampaign';

export const useJackpotPools = () => {
  const { campaign, isLoading } = useCurrentJackpotCampaign();

  const pools = useMemo(
    () => (campaign ? toPools(campaign.levels) : []),
    [campaign]
  );

  return { pools, isLoading };
};
